import "./dashboard-ui.css";

/**
 * Card wrapper for a chart/table block: colored icon + title on the left,
 * optional actions (export button, links...) on the right.
 */
export default function SectionCard({
  icon,
  color = "primary",
  title,
  actions,
  children,
  bodyClassName = "",
}) {
  return (
    <div className={`card section-card variant-${color}`}>
      <div className="section-card-header">
        <h4 className="section-card-title">
          {icon && (
            <span className="section-card-icon">
              <i className={`mdi ${icon}`}></i>
            </span>
          )}
          {title}
        </h4>
        {actions && <div className="d-flex align-items-center flex-wrap gap-2">{actions}</div>}
      </div>
      <div className={`card-body ${bodyClassName}`}>{children}</div>
    </div>
  );
}
